export default __webpack_public_path__ + "static/media/services-betriebseinrichtung.898abbe3.webp";